/**
 * Dependency imports
 */
import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

/**
 * Local imports
 */
import TransitionLink from './TransitionLink';

/**
 * Root
 */
const Root = styled('span', {
  shouldForwardProp: (prop: PropertyKey) =>
    !['opacity', 'hoverOpacity'].includes(prop.toString()),
})<Partial<OpacityLinkCombinedProps>>(
  ({ opacity = 0.7, hoverOpacity = 1 }) => css`
    opacity: ${opacity};
    transition: 200ms opacity;

    &:hover {
      opacity: ${hoverOpacity};
    }
  `
);

/**
 * OpacityLink Component
 */
export interface OpacityLinkProps {
  href: string;
  target?: '_blank' | '_self';
  opacity?: number;
  hoverOpacity?: number;
  transition?: boolean;
  onClick?: () => void;
  ariaLabel?: string;
}

export type OpacityLinkCombinedProps = OpacityLinkProps &
  JSX.IntrinsicElements['span'];

const OpacityLink: React.FC<OpacityLinkCombinedProps> = ({
  href,
  target,
  transition,
  onClick,
  children,
  ariaLabel,
  rel,
  ...props
}) => {
  return (
    <Root {...props} onClick={onClick}>
      <TransitionLink href={href} target={target} ariaLabel={ariaLabel} transition={transition} rel={rel}>
        {children}
      </TransitionLink>
    </Root>
  );
};

export default OpacityLink;
